module.exports = __webpack_public_path__ + "static/img/MOOV.8a662421.png";